<template>
  <div>
    <a v-if="this.$auth.setting && this.$auth.setting.is_same_day_delivery == true" href="javascript:void(0)"
      class="lnk" @click="openTime">{{ $t('Change') }}</a>
    <div class="modal fade deliverytime-main" id="changetime" tabindex="-1" aria-labelledby="changetimeLabel"
      aria-hidden="true" ref="TimeModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="changetimeLabel">{{ $t('When Do You Want Your') }}
              {{ (isDelivery == 1 ||
                isDelivery
                == -1) ? $t('Delivery') : $t('Order') }}?</h4>
            <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body p-0">
            <div class="d-flex align-content-start">

              <!-- Day Tabs -->
              <ul v-if="!isLoading" class="nav nav-tabs flex-column border-0">
                <li class="nav-item" v-for="(day, index) in allDays" :key="index">
                  <a href="javascript:void(0);" @click="selectDate(day.date, day.day)" class="nav-link navbar-default"
                    data-bs-toggle="tab" :class="{ 'active': selectedDate == day.date }">
                    {{ day.day }}
                  </a>
                </li>
              </ul>

              <!-- Time Slots for Selected Day -->
              <div v-if="!isLoading" class="tab-content">
                <div id="tab1" class="tab-pane active tab-box sub-desc" v-if="selectedDayObject">
                  <form class="boxed d-flex flex-column">

                    <!-- ASAP Section -->
                    <div class="asap" v-if="isToday && isAsapEnable && restaurantData.restaurant_on_off">
                      <input type="radio" id="asap" name="time" value="asap" v-model="selectedTime"
                        @click="getCurrentTime()" />
                      <label for="asap">{{ $t('As Soon As Possible') }}</label>
                    </div>

                    <!-- Slots -->
                    <div v-if="selectedDayObject.slots && selectedDayObject.slots.length">
                      <template v-for="(time, index) in selectedDayObject.slots">
                        <div class="timeslots" v-if="time">
                          <input type="radio" :id="'time_' + index" name="time" :value="time.label"
                            v-model="selectedTime" @click="setSecondaryTime(time, time.value)" />
                          <label :for="'time_' + index">{{ time.label }}</label>
                        </div>
                      </template>
                    </div>

                    <!-- No Slots -->
                    <div v-else class="notimeslot">
                      <img src="@/assets/images/no-time-slot.svg" />
                      <p class="text-muted">{{ $t('No slots available for this day.') }}</p>
                    </div>
                  </form>
                </div>
              </div>

              <!-- <div v-else class="notimeslot">
                <img src="@/assets/images/no-time-slot.svg" />
                <p>{{ $t('No time slot available') }}</p>
              </div> -->

              <div class="loaderdiv h-100 d-flex justify-content-center align-items-center" v-if="isLoading">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </div>
          </div>
          <div v-if="!isLoading" class="modal-footer full-btn d-block">
            <a href="javascript:void(0);" @click="setTime()">{{ $t('Set') }} {{ (isDelivery == 1 || isDelivery == -1) ?
              $t('Delivery') : $t('Takeaway') }} {{ $t('time') }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
export default {
  props: ['restaurantId', 'restaurantData', 'isDelivery'],
  data() {
    return {
      moment: moment,
      isLoading: false,
      selectedDate: '',
      times: [],
      selectedTime: '',
      selectedSecondaryTime: '',
      isToday: false,
      isAsapEnable: false,
      timeFormat: 'HH:mm:ss',
      dateFormat: 'YYYY-MM-DD',
      defaultDayname: '',
      time_slots: 0,
      store_delivery_time: [],
      store_takeaway_time: [],
      system_start_time: '',
      system_end_time: '',
      is_same_day_delivery: 0,
      is_enable_schedule_order_after_business_hours: 0,
      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      currentDate: new Date(),
      currentTime: new Date().toLocaleTimeString(),
      currentMinute: new Date().getMinutes(),
      currentDay: '',
      allDays: [],
      opencloseTimes: [],
      statTimeSlot: [],
      restaurantTimingList: [],
      selectedTimeValue: '',
    }
  },
  mounted() {
    this.currentDay = this.days[this.currentDate.getDay()];
  },

  computed: {
    ...mapGetters("order", ["isPickupDelivery"]),

    selectedDayObject() {
      return this.allDays.find(day => day.date == this.selectedDate);
    }

  },
  methods: {
    ...mapActions("restaurant", ["getRestaurantTimingData"]), //To get restaurant timings
    // To re-init all the data

    getCurrentTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
      const day = now.getDate().toString().padStart(2, '0');
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      const seconds = now.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },




    formatToAmPm(time) {
      if (!time || typeof time !== 'string' || !time.includes(':')) return time;
      const parts = time.split(':');
      const hour = parseInt(parts[0], 10);
      const minute = parseInt(parts[1], 10);
      if (isNaN(hour) || isNaN(minute)) return time;
      const suffix = hour >= 12 ? 'PM' : 'AM';
      const hour12 = hour % 12 || 12;
      return `${hour12}:${minute.toString().padStart(2, '0')} ${suffix}`;
    },
    formatTimeLabel(timeStr) {
      if (!timeStr) return '';
      if (timeStr.includes('-')) {
        return timeStr
          .split('-')
          .map(t => this.formatToAmPm(t.trim()))
          .join(' - ');
      } else {
        return this.formatToAmPm(timeStr);
      }
    },

    openTime() {
      window.$("#changetime").on('show.bs.modal', function () { });
      window.$("#changetime").modal("show");
      window.$(this.$refs.TimeModal).modal();
      //Get restaurant timings
      this.getRestaurantTiming();
    },
    // To create left side days list


    getRestaurantTiming() {
      let vm = this;
      let deliveryType = 1;
      if (this.isPickupDelivery == 1 || this.isPickupDelivery == -1) {
        deliveryType = 1;
      } else {
        deliveryType = 0;
      }
      this.getRestaurantTimingData({
        params: {
          restaurant_id: this.restaurantId,
          // is_delivery: this.isPickupDelivery == 0 ? true : false,
          is_delivery: deliveryType,
        }
      }).then((response) => {
        if (response.status == true) {
          this.restaurantTimingList = response.data;
          if (this.restaurantTimingList) {
            this.allDays = this.restaurantTimingList;
            // first time open then i want to set the selected date to the first available date
            if (!this.selectedDate || this.selectedDate === '') {
              this.selectedDate = this.allDays[0].date;
            }
            // Optional: Also set selected index if needed
            this.selectedDayIndex = this.allDays.findIndex(day => day.date === this.selectedDate);
          }
          this.isLoading = false;
        } else {
          this.isLoading = false;
          alert((response.message != '') ? response.message : this.$t('Something went wrong, Please try again.'));
        }
      }).catch(function () {
        vm.isLoading = false;
        alert(vm.$t('Something went wrong, Please try again.'));
      });
    },
    // On click on day this function will call to retrive all timings
    selectDate(date, day) {
      this.selectedDate = date;
      // this.selectedTime = (isToday && this.isAsapEnable) ? 'asap' : '';
      this.selectedSecondaryTime = '';
      this.selectedTime = '';
    },

    // To set end time
    setSecondaryTime(time, value) {
      this.selectedTimeValue = value;
      this.selectedSecondaryTime = time.label;
    },
    // On click on set delivery/pickup time this will handle and pass data
    setTime() {
      if (this.selectedDate !== '' && this.selectedTime !== '') {
        let selMoment = moment(this.selectedDate);
        let day = selMoment.format('ddd');
        let monthname = selMoment.format('MMM');
        let daynum = selMoment.format('D');

        let todayTomm = '';
        switch (this.selectedDate) {
          case moment().format(this.dateFormat):
            todayTomm = 'Today';
            break;
          case moment().add(1, 'day').format(this.dateFormat):
            todayTomm = 'Tomorrow';
            break;
          default:
            todayTomm = `${day}, ${monthname}-${daynum > 9 ? daynum : '0' + daynum}`;
            break;
        }
        // This will just include the selected day label and time (not full date)
        // let asps = ''
        // if (this.selectedTime == 'As Soon As Possible') {
        //   asps = this.getCurrentTime()
        // }
        // let displayText = todayTomm + ', ' + this.formatTimeLabel(this.selectedTime);
        let displayText = todayTomm + ', ' + this.selectedTime;
        // Emit only displayText and selectedTime (no raw date)
        this.$emit("setOrderTime", {
          // day: this.selectedDate + ' ' + this.selectedTimeValue,
          day: (this.selectedTimeValue == '' || this.selectedTimeValue == null) ? "" : this.selectedDate + ' ' + this.selectedTimeValue,
          time: this.selectedTime,
          displayText: displayText
        });
        window.$("#changetime").on('show.bs.modal', function () { });
        window.$("#changetime").modal("hide");
      } else {
        alert(this.$t("Please select date and time both"));
      }
    }
  },
};
</script>
<style scoped>
/* To set loader on center of modle */
.loaderdiv {
  width: 100%;
  position: absolute;
}
</style>